module.exports = new __parcel__URL__("llama.d767d641.svg").toString();